/**
 *  @class
 *  @function LayeredImagesV2
 */

if (!customElements.get('layered-images-v2')) {
 	class LayeredImagesV2 extends HTMLElement {
	  constructor() {
			super();
	  }
		connectedCallback() {
			if ( document.body.classList.contains('animations-true') && typeof gsap !== 'undefined') {
				this.prepareAnimations();
			}
		}
		prepareAnimations() {
			let section = this.closest('.shopify-section'),
					image_1 = section.querySelector('.layered-image-1'),
					image_2 = section.querySelector('.layered-image-2'),
					image_3 = section.querySelector('.layered-image-3'),
					image_4 = section.querySelector('.layered-image-4');

			let property = () => {
		  	return gsap.getProperty("html", "--header-height", "px");
			};
			if(image_1) {
				gsap.to(image_1, {
					y: '-8%',
					ease: "power1.out",
					scrollTrigger: {
						trigger: this,
						scrub: 1,
						start: () => `top 90%`,
						end: () => `bottom top+=${property()}`
					}
				});
			}

			if(image_2) {
				gsap.to(image_2, {
					y: '30%',
					ease: "power1.out",
					scrollTrigger: {
						trigger: this,
						scrub: 1,
						start: () => `top 90%`,
						end: () => `bottom top+=${property()}`
					}
				});
			}

			if(image_3) {
				gsap.to(image_3, {
					y: '-30%',
					ease: "power1.out",
					scrollTrigger: {
						trigger: this,
						scrub: 1,
						start: () => `top 90%`,
						end: () => `bottom top+=${property()}`
					}
				});
			}

			if(image_4) {
				gsap.to(image_4, {
					y: '20%',
					ease: "power1.out",
					scrollTrigger: {
						trigger: this,
						scrub: 1,
						start: () => `top 90%`,
						end: () => `bottom top+=${property()}`
					}
				});
			}

		}
	}
	customElements.define('layered-images-v2', LayeredImagesV2);
}
